import React, { useEffect, useState } from 'react';
import './splash-screen.scss';

interface SplashScreenProps {
  onComplete: () => void;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // إخفاء SplashScreen بعد 4 ثوانٍ
    const timer = setTimeout(() => {
      setIsVisible(false);
      // تأخير إضافي للـ transition
      setTimeout(() => {
        onComplete();
      }, 500);
    }, 4000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="splash-screen">
      {/* الصورة كخلفية فقط */}
    </div>
  );
};

export default SplashScreen;
